import * as Yup from 'yup'
import { useFormik } from 'formik'
import { format, subDays, differenceInDays } from 'date-fns'

//NOTE: do not change id's values. They're used for startDate calculation
const ALL_RESULTS = 'all'
const LAST_24H_DIFF_DAYS = '0'
const LAST_3D_DIFF_DAYS = '2'
const LAST_7D_DIFF_DAYS = '6'
const LAST_STATUS_DATE_OPTIONS = [
  {
    id: ALL_RESULTS,
    label: 'Todos',
  },
  {
    id: LAST_24H_DIFF_DAYS,
    label: 'Últimas 24h',
  },
  {
    id: LAST_3D_DIFF_DAYS,
    label: 'Últimos 3 días',
  },
  {
    id: LAST_7D_DIFF_DAYS,
    label: 'Última semana',
  },
]
const LAST_STATUS_IDS_OPTIONS = LAST_STATUS_DATE_OPTIONS.map(opt => opt.id)

const validationSchema = Yup.object().shape({
  statusCode: Yup.array().of(Yup.object()
    .shape({ code: Yup.string(), label: Yup.string() })
    .required('error:field:required')),
  incidentCode: Yup.array().of(Yup.object()
    .shape({ code: Yup.string(), label: Yup.string() })
    .required('error:field:required')),
  serviceType: Yup.object().shape({
    code: Yup.string(),
    name: Yup.string(),
    label: Yup.string(),
    originalCode: Yup.string(),
  }),
  senderAddress2: Yup.string(),
  recipientAddress2: Yup.string(),
  lastStatusDate: Yup.string(),
})

const getIntervalDateFilter = ({ dateTo, dateFrom }) =>
  dateTo && dateFrom
    ? differenceInDays(new Date(dateTo), new Date(dateFrom)).toString()
    : null

const getInitialValues = (initialFilters, options) => {
  const intervalDateFilter = getIntervalDateFilter(initialFilters)
  return {
    incidentCode: [],
    statusCode:
      options?.statusCode?.find(
        opt => opt.code === initialFilters.statusCode,
      ) ?? [],
    serviceType:
      options?.serviceType?.find(
        opt => opt.code === initialFilters.serviceType,
      ) ?? '',
    senderAddress2: initialFilters.senderAddress2 ?? '',
    recipientAddress2: initialFilters.recipientAddress2 ?? '',
    lastStatusDate: LAST_STATUS_IDS_OPTIONS.includes(intervalDateFilter)
      ? intervalDateFilter
      : ALL_RESULTS,
  }
}

const DEFAULT_VALUES = {
  incidentCode: [],
  statusCode: [],
  serviceType: '',
  senderAddress2: '',
  recipientAddress2: '',
  lastStatusDate: ALL_RESULTS,
}

const getParamFilters = values => {
  const filters = {}

  for (const [key, value] of Object.entries(values)) {
    if ((key === 'statusCode' || key === 'serviceType') && value?.code)
      filters[key] = value.code
    else if (key === 'lastStatusDate') {
      if (value !== ALL_RESULTS) {
        filters['dateFrom'] = format(subDays(new Date(), value), 'yyyy-MM-dd')
        filters['dateTo'] = format(new Date(), 'yyyy-MM-dd')
      }
    } else if (value !== '') filters[key] = value
    //TODO: delete previous filters if now its value is null ??
  }
  return filters
}

const getOptions = (statusOptions, serviceTypeOptions) => ({
  statusCode: statusOptions?.length
    ? statusOptions.map(op => ({ ...op, label: op.name })) ?? []
    : [],
  incidentCode: [],
  serviceType: serviceTypeOptions ?? [],
  lastStatusDate: LAST_STATUS_DATE_OPTIONS,
})

const useFiltersModalForm = (
  onConfirm,
  initialFilters,
  statusOptions,
  serviceTypeOptions,
) => {
  const options = getOptions(statusOptions, serviceTypeOptions)
  const initialValues = getInitialValues(initialFilters, options)

  const formik = useFormik({
    validationSchema,
    initialValues,
  })

  const handleSubmit = ev => {
    ev.preventDefault()
    const filters = getParamFilters(formik.values)
    onConfirm(filters)
  }

  const handleReset = () => formik.setValues(DEFAULT_VALUES)

  return { formik, handleSubmit, handleReset, options }
}

export default useFiltersModalForm
